import { DirectionsRunIcon, EventIcon } from "../components/icons";
import React from "react";
import { useSelector } from "react-redux";
import OrderSchedulerModal from "../components/OrderSchedulerModal";
import SchedulerDay from "../components/SchedulerDay";
import { CheckoutRow } from "../components/CheckoutSection";

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

const generateSchedulingText = (orderScheduling) => {
  const selectedDate = new Date(orderScheduling.schedule.date);
  const today = selectedDate.getDate() === new Date().getDate();
  const weekday = today
    ? "Hoje,"
    : selectedDate.toLocaleDateString("pt-BR", {
        weekday: "short",
      });

  return `${weekday} ${orderScheduling.schedule.hoursInterval}`;
};

export default function OrderScheduler() {
  const orderScheduling = useSelector(
    (state) => state.checkout.orderScheduling,
  );

  const [isSchedulerOpen, setSchedulerOpen] = React.useState(false);

  const openScheduler = () => setSchedulerOpen(true);
  const closeScheduler = () => setSchedulerOpen(false);

  return (
    <>
      <CheckoutRow
        icon={
          orderScheduling.isScheduledOrder ? (
            <EventIcon />
          ) : (
            <DirectionsRunIcon />
          )
        }
        title={
          orderScheduling.isScheduledOrder
            ? capitalize(generateSchedulingText(orderScheduling))
            : "Pedido para agora"
        }
        actionLabel="Trocar"
        onClick={openScheduler}
      >
        {orderScheduling.isScheduledOrder && (
          <span className="checkout-row__subtitle">Pedido agendado</span>
        )}
      </CheckoutRow>
      <OrderSchedulerModal isOpen={isSchedulerOpen} onClose={closeScheduler} />
    </>
  );
}

function OrderSchedulerConfirmation() {
  const { toGo, orderScheduling } = useSelector((state) => state.checkout);

  const label = toGo ? "Retirada Agendada" : "Entrega Agendada";

  return (
    <div className="d-flex flex-row align-items-center pt-3 pb-5">
      <SchedulerDay
        date={new Date(orderScheduling.schedule.date)}
        borderColor={"border-secondary"}
        textColor={"text-secondary"}
        onClick={(e) => e.preventDefault()}
      />
      <div className="d-flex flex-column ms-3">
        <p className="m-1">{label}</p>
        <p className="m-1 text-capitalize">
          {generateSchedulingText(orderScheduling)}
        </p>
      </div>
    </div>
  );
}

export { OrderSchedulerConfirmation };
